import { render, staticRenderFns } from "./VRequestStep0.vue?vue&type=template&id=66af1f9d&"
import script from "./VRequestStep0.vue?vue&type=script&lang=js&"
export * from "./VRequestStep0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports